import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["lng", "subpath"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
// import Router from 'next/router'

import { APP_DOMAIN } from '@app/constants';
import { Router } from '../config/i18n';
import { isOrganiser } from './authorization';
import { isAbsoluteURL } from './strings';
var _require = require('../server/routes'),
  routes = _require.routes;
var parseRouteUrl = function parseRouteUrl(route, params) {
  for (var key in params) {
    var regex = new RegExp(":".concat(key), "g");
    route = route.replace(regex, params[key]);
  }
  return route;
};
export var generateLink = function generateLink(pathname, query) {
  var queryParams = '';
  if (query) {
    var queryArr = Object.entries(query);
    queryArr.forEach(function (item, index) {
      queryParams = "".concat(queryParams).concat(item[0], "=").concat(item[1]).concat(index !== queryArr.length - 1 ? '&' : '');
    });
  }
  return "".concat(pathname).concat(queryParams !== '' ? "?".concat(queryParams) : '');
};
export var redirect = function redirect(context, target, params) {
  if (context.res) {
    // server
    // 303: "See other"
    context.res.writeHead(303, {
      Location: target
    });
    context.res.end();
  } else {
    // In the browser, we just pretend like this never even happened ;)
    if (!Object.prototype.hasOwnProperty.call(routes, target)) {
      Router.push(target);
      return;
    }
    var routeDetails = routes[target];
    if (params) {
      Router.push({
        pathname: routeDetails.component,
        query: _objectSpread({}, params)
      }, generateLink(routeDetails.url, _objectSpread({}, params)));
    } else {
      Router.push(routeDetails.component, generateLink(routeDetails.url, _objectSpread({}, params)));
    }
  }
};

/**
 * This function is used to replace Link params with the params object
 * @param {*} route
 * @param {*} params
 * @returns
 */
export var getUrlFromRoute = function getUrlFromRoute(routeName, config) {
  var _ref = config || {},
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? null : _ref$query,
    _ref$absolute = _ref.absolute,
    absolute = _ref$absolute === void 0 ? true : _ref$absolute,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en' : _ref$locale;
  var url = routeName;
  if (Object.prototype.hasOwnProperty.call(routes, routeName)) {
    var routeDetails = routes[routeName];
    // In the browser, we just pretend like this never even happened ;)
    url = params ? parseRouteUrl(routeDetails.url, params) : routeDetails.url;
    if (query) {
      var qs = new URLSearchParams(query).toString();
      url += "?".concat(qs);
    }
  }
  if (absolute && !isAbsoluteURL(url)) {
    url = "".concat(APP_DOMAIN, "/").concat(locale).concat(url);
  }
  return url;
};
var getRouteDetails = function getRouteDetails(route) {
  var routeParts = route === null || route === void 0 ? void 0 : route.split('.');
  var routeDetails = routes;
  if (!routeDetails || !Object.prototype.hasOwnProperty.call(routeDetails, routeParts[0])) {
    console.error("Route \"".concat(route, "\" does not exist."));
    return null;
  }
  routeDetails = routeDetails[routeParts[0]];
  if (routeDetails.routes) {
    var _iterator = _createForOfIteratorHelper(routeDetails.routes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var childRoute = _step.value;
        if (childRoute.name === routeParts[1]) {
          return childRoute;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return routeDetails;
};
export var redirectToRoute = function redirectToRoute(context, route) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? {} : _ref2$params,
    query = _ref2.query;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  var routeDetails = getRouteDetails(route);
  if (!routeDetails) {
    return false;
  }
  // In the browser, we just pretend like this never even happened ;)
  var url = params ? parseRouteUrl(routeDetails.url, params) : routeDetails.url;
  if (query) {
    var qs = new URLSearchParams(query).toString();
    url += "?".concat(qs);
  }
  if (context !== null && context !== void 0 && context.res) {
    // server
    // 303: "See other"
    context.res.writeHead(303, {
      Location: url
    });
    context.res.end();
    return false;
  }
  Router.push({
    pathname: routeDetails.component,
    query: _objectSpread(_objectSpread({}, params), query)
  }, url, options);
  return true;
};
function setIntendedRoute(query, route) {
  var _ref3 = query || {},
    lng = _ref3.lng,
    subpath = _ref3.subpath,
    params = _objectWithoutProperties(_ref3, _excluded);
  return JSON.stringify({
    name: route,
    params: params
  });
}
export var goToLogin = function goToLogin(context) {
  var nextRoute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/login";
  var intended = setIntendedRoute(context.query, nextRoute);
  if (context && context.res) {
    // server
    // 303: "See other"

    context.res.writeHead(303, {
      Location: "".concat(routes.login.url, "?next=").concat(intended)
    });
    // context.res.writeHead(303, { Location: routes.login.url });
    context.res.end();
    return;
  }
  redirectToRoute({}, 'login', {
    query: {
      next: intended
    }
  });
};
export var goToDashboard = function goToDashboard(context, user) {
  var route = user && isOrganiser(user) ? routes.my_opportunities : routes.opportunity_search;
  if (context && context.res) {
    context.res.writeHead(303, {
      Location: route.url
    });
    context.res.end();
    return;
  }
  Router.push({
    pathname: route.component
  }, route.url);
};
export var intended = function intended() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$next = _ref4.next,
    next = _ref4$next === void 0 ? null : _ref4$next;
  var defaultRoute = arguments.length > 1 ? arguments[1] : undefined;
  if (!next) {
    Router.push(defaultRoute ? routes[defaultRoute].url : '/');
  }
  try {
    var routeInfo = JSON.parse(next);
    redirectToRoute({}, routeInfo.name, {
      params: routeInfo.params
    });
  } catch (err) {
    Router.push(defaultRoute ? routes[defaultRoute].url : '/');
  }
};